export default {
  name: 'NotFound'
}
